import { render, staticRenderFns } from "./CurriculumReadEECPure.vue?vue&type=template&id=5abda3ec&scoped=true&"
import script from "./CurriculumReadEECPure.vue?vue&type=script&lang=ts&"
export * from "./CurriculumReadEECPure.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumReadEECPure.vue?vue&type=style&index=0&id=5abda3ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abda3ec",
  null
  
)

export default component.exports